/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPhotoCameraIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-photo-camera"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 17.65Q13.95 17.65 15.3 16.29Q16.65 14.93 16.65 13Q16.65 11.05 15.3 9.7Q13.95 8.35 12 8.35Q10.07 8.35 8.71 9.7Q7.35 11.05 7.35 13Q7.35 14.93 8.71 16.29Q10.07 17.65 12 17.65ZM12 15Q11.15 15 10.57 14.43Q10 13.85 10 13Q10 12.18 10.57 11.59Q11.15 11 12 11Q12.82 11 13.41 11.59Q14 12.18 14 13Q14 13.85 13.41 14.43Q12.82 15 12 15ZM3.85 21.8Q2.75 21.8 1.98 21.02Q1.2 20.25 1.2 19.15L1.2 6.85Q1.2 5.75 1.98 4.97Q2.75 4.2 3.85 4.2L6.88 4.2L8.15 2.95Q8.53 2.6 9 2.4Q9.47 2.2 10 2.2L14 2.2Q14.53 2.2 15 2.4Q15.47 2.6 15.85 2.95L17.13 4.2L20.15 4.2Q21.25 4.2 22.02 4.97Q22.8 5.75 22.8 6.85L22.8 19.15Q22.8 20.25 22.02 21.02Q21.25 21.8 20.15 21.8Z" fill={color} />
    </svg>
  );
}
